import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { BANK_CONFIG } from './bankConfig';

@Directive({
	selector: '[bankAccountFormat]',
	providers: [
		{
			provide: NG_VALIDATORS,
			useExisting: BankAccountFormatDirective,
			multi: true
		}
	]
})
export class BankAccountFormatDirective implements Validator {

	@Input() bankId!: number;

	constructor(private el: ElementRef<HTMLInputElement>) { }

	@HostListener('input')
	onInput(): void {
		const config = BANK_CONFIG[this.bankId];

		if (!config) return;

		let value = this.el.nativeElement.value || '';

		// digits only
		value = value.replace(/\D/g, '');
		value = value.substring(0, config.maxLength);

		// format
		this.el.nativeElement.value = config.format(value);
	}

	validate(control: AbstractControl): ValidationErrors | null {
		const config = BANK_CONFIG[this.bankId];
		if (!config || !control.value) return null;

		const digits = control.value.replace(/\D/g, '').substring(0, config.maxLength);
		return digits.length === config.maxLength ? null : { pattern: true };
	}
}
